export const ItemTypes = {
    TYPE: "project",
};
